import { render, staticRenderFns } from "./softwareVideoDetail.vue?vue&type=template&id=14404484&scoped=true&"
import script from "./softwareVideoDetail.vue?vue&type=script&lang=js&"
export * from "./softwareVideoDetail.vue?vue&type=script&lang=js&"
import style0 from "./softwareVideoDetail.vue?vue&type=style&index=0&id=14404484&prod&lang=css&"
import style1 from "./softwareVideoDetail.vue?vue&type=style&index=1&id=14404484&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14404484",
  null
  
)

export default component.exports